exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select-dropdown__item.hover[data-v-c47c80ac],.el-select-dropdown__item[data-v-c47c80ac]:hover{background-color:transparent}.el-tree-node__label.disabled[data-v-c47c80ac]{color:#c0c4cc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c47c80ac","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./packages/element-ui-expand/src/JElSelectTree.vue
// module id = 94
// module chunks = 0